import {Component, OnInit, Input, SimpleChanges, OnChanges, Output, EventEmitter} from '@angular/core';
import {User} from 'src/app/services/user/user';
import {BehaviorSubject} from 'rxjs';
import {UntypedFormGroup, UntypedFormBuilder, UntypedFormArray} from '@angular/forms';
import {UserPreference} from '../user-preferences/user-preference';
import {PrefItem} from '../user-preferences/pref-item';
import {UserService} from 'src/app/services/user/user.service';
import {UserPreferencesService} from 'src/app/services/user-preferences/user-preferences.service';
import {Router} from '@angular/router';
import {AlertService} from 'src/app/services/alert/alert.service';
import {LoadingService} from 'src/app/services/loading/loading.service';
import {takeWhile} from 'rxjs/operators';

@Component({
    selector: 'app-user-pref-body',
    templateUrl: './user-pref-body.component.html',
    styleUrls: ['./user-pref-body.component.css'],
    standalone: false
})
export class UserPrefBodyComponent implements OnInit, OnChanges {
  currentUser: User;
  tmssloader: any;
  private observer$ = new BehaviorSubject(true);
  userPreferencesBodyForm: UntypedFormGroup;
  userPref: UserPreference;
  selectAll = false;
  userPrefList: PrefItem[];
  saveBtnDisable: boolean;
  @Input() screenName: any;
  @Output() showBody = new EventEmitter<boolean>();
  @Output() updateTable = new EventEmitter<any>();

  constructor(private fb: UntypedFormBuilder,
              private userService: UserService,
              private userPreferencesService: UserPreferencesService,
              private router: Router,
              private alertService: AlertService,
              private loader: LoadingService) {
    this.tmssloader = this.loader;
    this.userService.getCurrentUserObservable().pipe(takeWhile(() => this.observer$.value)).subscribe(currentUser => {
      this.currentUser = currentUser;
    });
  }

  ngOnInit(): void {
    this.userPreferencesBodyForm = this.fb.group({
      prefs: new UntypedFormArray([]),
    });

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.saveBtnDisable = false;
    const userId = this.currentUser.userSessionEntity.userId;
    const orgId = this.currentUser.userSessionEntity.organizationId;
    this.userPreferencesService.getUserPrefs(userId, orgId, this.screenName).subscribe(result => {
      this.userPref = result;
      this.userPrefList = this.userPref.listPrefs;
      console.log(this.userPrefList);
    });
  }


  onCheckboxChange(name: string, isChecked: boolean) {
    this.selectAll = false;
    this.userPrefList.forEach(item => {
      if (item.headerName === name) {
        item.isVisible = isChecked;
      }
    });
  }

  savePref() {
    this.loader.show();
    this.userPreferencesService.saveUserPrefs(this.userPref).subscribe(
      result => {
        this.alertService.success('Your data view preferences have been saved successfully. ');
        this.updateTable.emit(this.userPref.listPrefs);
        this.loader.hide();
      }, error => {
        this.alertService.error('Error while storing your data view preferences.');
        this.loader.hide();
      });
  }

  onSelectAll(val) {
    console.log(val);
    this.selectAll = val;
    if (this.selectAll) {
      this.userPref.listPrefs.forEach(pref => pref.isVisible = true);
    } else {
      this.userPref.listPrefs.forEach(pref => pref.isVisible = false);
    }
  }

  closePref() {
    this.showBody.emit(false);
  }

}
